import { SignUpWizard } from '@hero/web-components';

/**
 * Public auth route — mounts the unified, shared signup wizard from
 * `@hero/web-components`. The wizard owns its own header (title +
 * subtitle), so this page is just the framing card.
 *
 * The legacy `RegistrationBox` + `PersonTapsForm` UI has been
 * retired; see `.cursorrules` ("Single web dashboard direction") for
 * the rollout context.
 */
export default function ChoosePerson() {
  return (
    <div className="w-full">
      <img
        src="/images/logos/hero-logo-small.svg"
        alt="Hero"
        className="mx-auto mb-6 h-20 w-20"
      />
      <SignUpWizard />
    </div>
  );
}
